// extracted by mini-css-extract-plugin
module.exports = {"rowProduct":"ProductDetail_rowProduct__1HsLD","input_number":"ProductDetail_input_number__1mVx2","input_text":"ProductDetail_input_text__3OeW_"};